import React from 'react';
import Providers from '../../components/AdminNext/Providers';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Providers — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <Providers />
      </HeadLessLayout>
    )
  };
}

export default action;
